export function hexToRgba(hex: string, opacity: number = 0.1): string {
  const sanitizedHex = hex.startsWith("#") ? hex.slice(1) : hex;

  if (sanitizedHex.length !== 6) {
    throw new Error("Invalid hex color format. Expected '#RRGGBB'.");
  }

  const r = parseInt(sanitizedHex.slice(0, 2), 16);
  const g = parseInt(sanitizedHex.slice(2, 4), 16);
  const b = parseInt(sanitizedHex.slice(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

export function transformString(input: string): string {
  // Replace all occurrences of '.' or '_' with '-'
  const transformed = input.replace(/[._]/g, "-");

  // Append '-rec' at the end
  return `${transformed}-rec`;
}
